import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const RunningCostForm = forwardRef(({year, month, cost, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={cost}
      type="cost"
      fieldsComponent={Fields}
      onSave={useCallback(({id, amount, notes}) => (
        services.runningCost.saveCost({
          ...(id ? {id} : {}),
          year,
          month: month.month,
          amount,
          notes
        })
      ), [services, year, month])}
      onSaved={onSaved}
    />
  );
});

export default RunningCostForm;
